const // host="http://iraq-gis.com:3001/"
  host="https://tax.is.iq/api/public/api/"
  //  host="http://127.0.0.1:8082/api/"
  // host="http://192.168.80.4:3000/"
  // host="http://192.168.80.176:8080/api/"
  // host = "http://jp.jahizni.com/api/public/api/";
// host="http://jp.data-crew.com/api/public/api/"
//  const FrontEndDomain="http://dev.ticket.is/";
 const FrontEndDomain = window.location.origin + '/';
// const FrontEndDomain= "http://jp.data-crew.com/"
// const FrontEndDomain = "http://jp.jahizni.com/";

export default host;
export { FrontEndDomain };
